module.exports = __webpack_public_path__ + "static/media/minecraft-3.6ad1457f.png";